import type { ErrorRegistryShape } from '../common/common.error';

export const EQUITY_CHANGE_ERROR = {
  NOT_FOUND_EQUITY_CHANGE: { status: 404, message: 'Equity change not found' },
  /** 그 시점 투자 종류에 등록할 수 없는 변동(예: Debt 에 무상증자 · 일반이 아닌 투자에 부분 회수) */
  BAD_REQUEST_EQUITY_CHANGE_NOT_APPLICABLE: {
    status: 400,
    message: 'Change is not applicable to the investment',
  },
  /** 완전 회수 이후 날짜의 투자 지분 변동 · 두 번째 완전 회수 */
  CONFLICT_INVESTMENT_EXITED: { status: 409, message: 'Investment is already completely exited' },
  /** 그 시점 보유 주식 수보다 많은 부분 회수 · 남은 주식이 없는 일반 투자의 회수(data.available = 그 시점 주식 수) */
  CONFLICT_INSUFFICIENT_SHARES: { status: 409, message: 'Not enough shares at the date' },
  /** 감액 상태가 아닐 때의 감액 취소 */
  CONFLICT_NOT_IMPAIRED: { status: 409, message: 'Investment is not impaired at the date' },
} as const satisfies ErrorRegistryShape;
